module.exports = __webpack_public_path__ + "img/coach.2a98ef26.svg";